import React from 'react';
import { generateId } from '../../helpers/helpers';
import { observer } from "mobx-react-lite"
import { Collapse } from "react-collapse"
import { Gig } from './types'
import { Config } from '../../types';
import { File } from '../FileList/types';

interface Props {
    gig: Gig;
    config: Config;
    setEditGig: Function;
    pushFile: Function;
    removeFile: Function;
}

const GigComponent = observer(({gig, config, setEditGig, pushFile, removeFile}: Props) => {
    const [gigInfoOpen, setGigInfoOpen] = React.useState(false)

    const dragOver = (ev: { preventDefault: () => void; }) => {
        ev.preventDefault()
    }

    const drop = (ev: { preventDefault: () => void; dataTransfer: { getData: (arg0: string) => string; }; }) => {
        ev.preventDefault();
        const fileToAppend = JSON.parse(ev.dataTransfer.getData("file"))
        if (!fileToAppend) return

        pushFile(fileToAppend)
    }

    return (
        <div className="gig" onDrop={config.admin ? drop : undefined} onDragOver={config.admin ? dragOver : undefined}>
            <h6 className="gig-title" onClick={() => setGigInfoOpen(!gigInfoOpen)}>
                <i className="gig-collapse-icon">
                    <i className={gigInfoOpen ? "chevron-up" : "chevron-down"}/>
                </i>
                {gig.name}
                {
                    config.admin ? 
                    <React.Fragment>
                        <button className="edit inline" onClick={(e) => {e.stopPropagation(); setEditGig()}}>Muokkaa</button>
                    </React.Fragment>
                    : null
                }
            </h6>
            <Collapse isOpened={gigInfoOpen}>
                <p className="gig-info gig-description">{gig.description}</p>
                <GigFileTable
                    gig={gig} config={config} removeFile={removeFile}
                ></GigFileTable>
            </Collapse>
        </div>
    )
})

interface GigFileTableProps {
    gig: Gig;
    config: Config;
    removeFile: Function;
}

export const GigFileTable = observer(({gig, config, removeFile}: GigFileTableProps) => {
    return (
        <div className="gig-table-container">
            <table className="gig-table">
                <tbody>
                    { gig.files?.map((file: any) => <GigFile key={"gig-file-" + generateId()} file={file} config={config} removeFile={removeFile} />) }
                </tbody>
            </table>
        </div>
    )
})

interface GigFileProps {
    file: File;
    config: Config;
    removeFile: Function;
}

const GigFile = ({file, config, removeFile}: GigFileProps) => {
    return (
        <tr>
            <td>
                <a href={`${config.siteurl}/${config.directory}${file.path}`}>{file.text}</a>&nbsp;
            </td>
            {
                config.admin ? <td><button onClick={() => removeFile(file)} className="rowbtn danger-alpha">-</button></td> : <td></td>
            }
        </tr>
    )
}

export default GigComponent